import React from 'react';
import { IoWarningOutline } from 'react-icons/io5';
import { IoMdInformationCircleOutline } from 'react-icons/io';
import { FaRegCircleCheck } from 'react-icons/fa6';

export const CustomWarning = ({ alertType, content, link, linkClick }) => {
	const elementos = [
		{ name: "error", classes: "bg-error-light text-error-main", icon: <IoMdInformationCircleOutline className='w-6 h-6 relative' /> },
		{ name: "warning", classes: "bg-[#FFF4CC] text-[#B55300]", icon: <IoWarningOutline className='w-6 h-6 relative' /> },
		{ name: "info", classes: "bg-neutras-grey-light bg-neutras-grey-light", icon: <IoMdInformationCircleOutline className='w-6 h-6 relative' /> },
		{ name: "success", classes: "bg-success-light text-success-main", icon: <FaRegCircleCheck className='w-6 h-6 relative' /> },
	]
	return (
		<div className={`py-[14px] px-[16px] rounded-md flex justify-start gap-3 ${elementos.find(e => e.name == alertType.value)?.classes}`}>
			<div className='w-6 h-6'>{elementos.find(e => e.name == alertType.value)?.icon}</div>
			{alertType.title} - {content} {link && "-" &&
				<a className="cursor-pointer no-underline text-base text-info-main" onClick={linkClick}> {link}</a>}
		</div>
	)
}
